import React from 'react';
import { useResponsive } from '@parsina/framework';
import TodayWeb from './Today.web.jsx';
import TodayMobile from './Today.mobile.jsx';

// امروز — two surfaces, one behaviour.
//
// ≤768px gets the mobile COCKPIT (DESIGN-CONCEPT-MOBILE §4) and NOT the desktop
// page reflowed: the gradient header with the date navigator inside it, the 4-up
// stat row riding its edge, and tappable cards instead of a nine-child flex row
// with a hover-repainted background.
//
// Both surfaces read the same `useToday` + `buildDayModel` + `dayCounts`, so
// they can look nothing alike and still can never disagree about who is next
// (§1.1: "the two surfaces may look nothing alike but must never disagree").
const TodayScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <TodayMobile /> : <TodayWeb />;
};

export default TodayScreen;
